import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from "react";
import { Field } from "formik";
import { FlexRowCenter } from "../../box";
import { Input } from "../atoms/TextualInput";
import { FieldError } from "../atoms/field-error";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FieldBorder } from "../atoms/FieldBorder";
import { LockIcon } from "../atoms";
import { Label } from "../atoms/Label";
import { ClearFieldButton } from "../atoms/clear-field-button";
import { isInvalid } from "../formHelpers";
import { useDebounce } from "../../hooks/useDebounce";
import { formatFieldValue, isValueFilled, processValue } from "./helpers";
export const TextField = ({ name, label, type, suffix, capitalize, numberOfBlocks, disabled, autoComplete, placeholder, renderBefore, renderAfter, fractionalDigits, uppercase, format, onChange, onFocus, onBlur, FormField, clearable = true, maxLength, ...props }) => {
    const [focused, setFocused] = useState(false);
    const [innerValue, setInnerValue, handleOnChange] = useDebounce(name, numberOfBlocks);
    return (_jsx(FormField, { name: name, type: type, children: ({ field, form }) => {
            const { value } = field;
            const { setFieldValue, setFieldTouched } = form;
            const isFilled = isValueFilled(value);
            const hasError = isInvalid(name, form);
            const onReset = () => {
                setInnerValue(suffix ?? "");
                setFieldValue(name, suffix ?? "");
            };
            return (_jsxs(Label, { children: [label && (_jsx(FloatingFieldLabel, { uppercase: uppercase, visible: isFilled, children: label })), _jsxs(FlexRowCenter, { children: [renderBefore({ value }), _jsx(Input, { autoComplete: autoComplete, name: name, value: innerValue !== undefined
                                    ? innerValue
                                    : isFilled
                                        ? processValue(fractionalDigits, innerValue)
                                        : "", placeholder: placeholder ?? label, onBlur: (event) => {
                                    setFocused(false);
                                    setFieldTouched(name, true);
                                    if (fractionalDigits) {
                                        if (event.currentTarget.value !== "") {
                                            setInnerValue(Number(event.currentTarget.value).toFixed(fractionalDigits));
                                            setFieldValue(name, Number(event.currentTarget.value).toFixed(fractionalDigits));
                                        }
                                    }
                                    onBlur?.(event);
                                }, onChange: (event) => onChange
                                    ? onChange(event)
                                    : handleOnChange(event, form, formatFieldValue(event.currentTarget.value, {
                                        type,
                                        name,
                                        suffix,
                                        format,
                                        capitalize,
                                        fractionalDigits,
                                    })), onFocus: (event) => {
                                    onFocus?.(event);
                                    setFocused(true);
                                }, disabled: disabled, type: type, "data-test-id": props["data-test-id"] ?? "", maxLength: maxLength }), renderAfter({ value }), isFilled && !disabled && clearable && (_jsx(ClearFieldButton, { onClick: onReset })), disabled && _jsx(LockIcon, {})] }), _jsx(FieldBorder, { focused: focused, invalid: hasError }), _jsx(FieldError, { name: name })] }));
        } }));
};
TextField.defaultProps = {
    type: "text",
    capitalize: true,
    renderBefore: () => null,
    renderAfter: () => null,
    FormField: Field,
    /**
     * HACK: prevents chrome address autofill. Not standard value.
     */
    autoComplete: "none",
};
